var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"place-marker"}},[_c('div',{attrs:{"id":"markers"}},_vm._l((_vm.questions),function(question,id){return _c('div',{key:id,class:question.id == _vm.status.position + 1 ? 'marker' + ' active': 'marker'})}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }